import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DocumentMeta from 'react-document-meta';
import eventBus from './lib/event-bus-rx';
import { configs } from './configs';
import { connectStream } from './lib/bastetjs/utils/connectStream';

window.APP_VERSION = '2.0.0';

export class AppMetaComponent extends Component {
  static propTypes = {
    pageTitle: PropTypes.string
  };

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.pageTitle !== this.props.pageTitle;
  }

  render() {
    const metaData = {
      link:  {
        rel: {
          stylesheet: [
            `${configs.cdnUrl}/css/global.css`,
            `${configs.cdnUrl}/css/react-smartbanner.css`,
            'https://fonts.googleapis.com/icon?family=Material+Icons',
            'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap'
          ],
          icon: [
            `${configs.cdnUrl}/images/favicon-16.png`,
            `${configs.cdnUrl}/images/favicon-32.png`,
            `${configs.cdnUrl}/images/favicon-96.png`,
            `${configs.cdnUrl}/images/favicon-128.png`
          ],
          'android-touch-icon': `${configs.cdnUrl}/images/favicon-96.png`,
          'apple-touch-icon': `${configs.cdnUrl}/images/favicon-96.png`
        },
      },
      meta: {
  	    charset: 'utf8',
  	    httpEquiv: {'X-UA-Compatible': 'IE=edge'},
  	    name: {
          viewport: 'width=device-width, initial-scale=1, maximum-scale=1.0',
          'apple-itunes-app': `app-id=${configs.iosAppId}`,
          'google-play-app': `app-id=${configs.androidAppId}`
        },
        property: {
          'fb:app_id': `${configs.fbAppId}`
        }
      },
      title: this.props.pageTitle || 'Athlinks'
    };

    return <DocumentMeta {...metaData} />
  }
}

export const AppMeta = connectStream({
  pageTitle: () => eventBus.getTopic('pageTitle')
})(AppMetaComponent);



/** WEBPACK FOOTER **
 ** ./AppMeta.js
 **/